import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTh } from '@fortawesome/free-solid-svg-icons';
import './LoginNavigationButton.css';

const LoginNavigationButton = ({ theme }) => {
  return (
    <Link to="/portals" className="login-nav-button" aria-label="Navigate to portal selection">
      <FontAwesomeIcon icon={faTh} className="login-nav-icon" />
      <span>Portals</span>
    </Link>
  );
};

export default LoginNavigationButton;